import { ValueTypes } from './ValueTypes';
import {
    KeyValuePair,
    Application,
    BulkEditProperty,
    HeaderStyle,
    AlarmLevel,
    TimeUnit,
    PropertyType,
    AggregationMode,
    ActualDataType,
    AcquisitionStrategy,
    ConnectionPointType,
    TagRenamingStrategy
} from '../models';

export * from './colors';

export const addLogbookEntryModalId = 'addLogbookEntryModal';
export const alarmsTableColumnsKey = 'alarmsTableColumns';
export const applicationsFavorites = 'applications-favorites';
export const authorizationDataKey = 'authorizationData';
export const calculatedDefaultState = 'calculated.general';
export const correspondanceTable = 'correspondanceTable';
export const dashboardRouteName = 'dashboard';
export const dashboardValuesUrl = 'values/dashboardSeriesValues';
export const dateFormat = 'yyyy-MM-dd HH:mm:ss,sss';
export const dateFormatShort = 'yyyy-MM-dd HH:mm:ss';
export const defaultItemPerPage = 48;
export const defaultSeriesColor = '#333';
export const defaultTicketAllowedFileTypes = ['.pdf', '.docx', '.xlsx', '.pptx', '.png', '.jpg', '.jpeg', '.bmp', '.gif', '.txt', '.csv'];
export const editGroupWidgetShapeState = 'groupShapes';
export const editGroupWidgetState = 'editGroupWidgetState';
export const editWidgetShapeState = 'shapes';
export const editWidgetState = 'editWidget';
export const globalTaskChannel = '39D37E9E-84AE-482D-8C2E-0AE1EDE9BFC5';
export const groupIdentifierSeparator = ' > ';
export const groupForbiddenCharacters = ['/'].concat([groupIdentifierSeparator]);
export const groupForbiddenStartingCharacters = ['.'];
export const guidEmpty = '00000000-0000-0000-0000-000000000000';
export const guidGroupValidationPageLink = '11111111-1111-1111-1111-111111111111';
export const missingId = 'missing';
export const missingSeries = 'Object does not exist';
export const momentFormat = 'YYYY-MM-DD HH:mm';
export const momentDateOnlyFormat = 'YYYY-MM-DD';
export const noneGroup = { key: guidEmpty, value: '<None>' };
export const saveErrorMessage = 'Save or cancel changes before selecting another tag.';
export const superAdminRole = 'super-administrator';
export const tagDefaultState = 'tag.general';
export const targetDefaultState = 'target.general';
export const validatedDefaultState = 'validated.general';
export const validationPageRouteName = 'validation';
export const wideService = 'WiDEService';
export const workspaceKey = 'Wt-Workspace';

//#region Connection points

export const tagSourceConnectionPointTypes = [
    ConnectionPointType.ArchestrA,
    ConnectionPointType.Argus,
    ConnectionPointType.Bazefield,
    ConnectionPointType.csv,
    ConnectionPointType.CSVDataTable,
    ConnectionPointType.DataFolder,
    ConnectionPointType.DataGeneration,
    ConnectionPointType.DataMailBox,
    ConnectionPointType.Ewattch,
    ConnectionPointType.FaSTInfluxDB2,
    ConnectionPointType.FaSTRepo,
    ConnectionPointType.GridVis,
    ConnectionPointType.HydrometrieKiwis,
    ConnectionPointType.Manual,
    ConnectionPointType.ManualFile,
    ConnectionPointType.MariaDB,
    ConnectionPointType.Npgsql,
    ConnectionPointType.OPCHDA,
    ConnectionPointType.Oracle,
    ConnectionPointType.PepiteDataLake,
    ConnectionPointType.PI,
    ConnectionPointType.PIAF,
    ConnectionPointType.SQL,
    ConnectionPointType.Wonderware
];

export const spotConnectionPointTypes = [
    ConnectionPointType.DataFolder,
    ConnectionPointType.DataGeneration,
    ConnectionPointType.Manual,
    ConnectionPointType.ManualFile
];

export const rawConnectionPointTypes = [
    ConnectionPointType.ArchestrA,
    ConnectionPointType.Argus,
    ConnectionPointType.csv,
    ConnectionPointType.CSVDataTable,
    ConnectionPointType.DataGeneration,
    ConnectionPointType.DataMailBox,
    ConnectionPointType.Ewattch,
    ConnectionPointType.FaSTInfluxDB2,
    ConnectionPointType.FaSTRepo,
    ConnectionPointType.GridVis,
    ConnectionPointType.HydrometrieKiwis,
    ConnectionPointType.MariaDB,
    ConnectionPointType.Npgsql,
    ConnectionPointType.OPCHDA,
    ConnectionPointType.Oracle,
    ConnectionPointType.PepiteDataLake,
    ConnectionPointType.PI,
    ConnectionPointType.PIAF,
    ConnectionPointType.SQL,
    ConnectionPointType.Wonderware
];

export const digitalRawConnectionPointTypes = [
    ConnectionPointType.ArchestrA,
    ConnectionPointType.FaSTInfluxDB2,
    ConnectionPointType.Npgsql,
    ConnectionPointType.OPCHDA,
    ConnectionPointType.PI,
    ConnectionPointType.PIAF
];

export const stringRawConnectionPointTypes = [
    ConnectionPointType.DataFolder,
    ConnectionPointType.Manual,
    ConnectionPointType.ManualFile,
    ConnectionPointType.PIAF
];

export const previousStepConectionPointTypes = [
    ConnectionPointType.ArchestrA,
    ConnectionPointType.DataGeneration,
    ConnectionPointType.OPCHDA,
    ConnectionPointType.PIAF,
    ConnectionPointType.Wonderware
];

export const digitalConnectionPointTypes = [
    ConnectionPointType.ArchestrA,
    ConnectionPointType.csv,
    ConnectionPointType.CSVDataTable,
    ConnectionPointType.DataFolder,
    ConnectionPointType.FaSTInfluxDB2,
    ConnectionPointType.FaSTRepo,
    ConnectionPointType.Manual,
    ConnectionPointType.ManualFile,
    ConnectionPointType.Npgsql,
    ConnectionPointType.OPCHDA,
    ConnectionPointType.PepiteDataLake,
    ConnectionPointType.PI,
    ConnectionPointType.PIAF
];

export const stringConnectionPointTypes = [
    ConnectionPointType.DataFolder,
    ConnectionPointType.Manual,
    ConnectionPointType.ManualFile,
    ConnectionPointType.PIAF
];

export const timestampConnectionPointTypes = [ConnectionPointType.Manual];

export const connectionPointsWithFrequency = [
    ConnectionPointType.DataGeneration,
    ConnectionPointType.FaSTRepo,
    ConnectionPointType.WideDatabase,
    ConnectionPointType.WideDatabaseNpgsql
];

export const exportConnectionPointTypes = [
    ConnectionPointType.HTTP,
    ConnectionPointType.PI,
    ConnectionPointType.PIAF,
    ConnectionPointType.SQL,
    ConnectionPointType.OPCHDA
];

export const outOfSyncConnectionPointTypes = [ConnectionPointType.ArchestrA, ConnectionPointType.PIAF, ConnectionPointType.SQL, ConnectionPointType.Wonderware];

export const importConnectionPointTypes = [
    // ConnectionPointType.DataFolder
    ConnectionPointType.ArchestrA,
    ConnectionPointType.CSVDataTable,
    ConnectionPointType.DataGeneration,
    ConnectionPointType.DataMailBox,
    ConnectionPointType.FaSTInfluxDB2,
    ConnectionPointType.FaSTRepo,
    ConnectionPointType.GridVis,
    ConnectionPointType.MariaDB,
    ConnectionPointType.Npgsql,
    ConnectionPointType.OPCHDA,
    ConnectionPointType.Oracle,
    ConnectionPointType.PI,
    ConnectionPointType.PIAF,
    ConnectionPointType.PepiteDataLake,
    ConnectionPointType.SQL,
    ConnectionPointType.Wonderware,
    ConnectionPointType.csv,
    ConnectionPointType.Ewattch,
    ConnectionPointType.HydrometrieKiwis
];

export const cpUsesPassword = [
    ConnectionPointType.ArchestrA,
    ConnectionPointType.Argus,
    ConnectionPointType.Bazefield,
    ConnectionPointType.DataMailBox,
    ConnectionPointType.Ewattch,
    ConnectionPointType.FaSTInfluxDB2,
    ConnectionPointType.GridVis,
    ConnectionPointType.HTTP,
    ConnectionPointType.MariaDB,
    ConnectionPointType.Oracle,
    ConnectionPointType.PepiteDataLake,
    ConnectionPointType.PIAF,
    ConnectionPointType.SMTP,
    ConnectionPointType.SQL,
    ConnectionPointType.WideDatabase,
    ConnectionPointType.WideDatabaseNpgsql
];

export const connectionPointTypes: KeyValuePair<ConnectionPointType, string>[] = [
    { key: ConnectionPointType.ManualFile, value: 'Bulk insert' },
    { key: ConnectionPointType.CSVDataTable, value: 'CSV tabulated file' },
    { key: ConnectionPointType.csv, value: 'CSV flat file' },
    { key: ConnectionPointType.DataGeneration, value: 'Data generation' },
    { key: ConnectionPointType.Excel, value: 'Excel file' },
    { key: ConnectionPointType.Manual, value: 'Manual input' },
    { key: ConnectionPointType.SQL, value: 'MS SQL' },
    { key: ConnectionPointType.OPCHDA, value: 'OPC HDA' },
    { key: ConnectionPointType.PI, value: 'PI' },
    { key: ConnectionPointType.PIAF, value: 'PI AF' },
    { key: ConnectionPointType.SMTP, value: 'SMTP' },
    { key: ConnectionPointType.WideDatabase, value: 'WiDE database' },
    { key: ConnectionPointType.WideDatabaseNpgsql, value: 'WiDE database PostgreSQL' },
    { key: ConnectionPointType.Wonderware, value: 'ArchestrA 2014' },
    { key: ConnectionPointType.PepiteDataLake, value: 'DATAlake' },
    { key: ConnectionPointType.DataFolder, value: 'Data folder' },
    { key: ConnectionPointType.HTTP, value: 'HTTP' },
    { key: ConnectionPointType.Oracle, value: 'Oracle' },
    { key: ConnectionPointType.GridVis, value: 'GridVis' },
    { key: ConnectionPointType.FaSTRepo, value: 'FaST repository' },
    { key: ConnectionPointType.CSVExport, value: 'CSV Export' },
    { key: ConnectionPointType.MariaDB, value: 'MariaDB' },
    { key: ConnectionPointType.ArchestrA, value: 'ArchestrA' },
    { key: ConnectionPointType.DataMailBox, value: 'Talk2M DataMailbox' },
    { key: ConnectionPointType.Npgsql, value: 'PostGreSQL' },
    { key: ConnectionPointType.FaSTInfluxDB2, value: 'FaST over InfluxDB2' },
    { key: ConnectionPointType.Bazefield, value: 'Bazefield' },
    { key: ConnectionPointType.Argus, value: 'Argus' },
    { key: ConnectionPointType.Ewattch, value: 'Ewattch' },
    { key: ConnectionPointType.HydrometrieKiwis, value: 'Walloon hydrometry API' }
];
//#endregion

export const tagDefinitionValues: KeyValuePair<string, string>[] = [
    ValueTypes.average,
    ValueTypes.gradient,
    ValueTypes.interpolated,
    ValueTypes.standardDeviation,
    ValueTypes.minimum,
    ValueTypes.maximum,
    ValueTypes.numberOfValues,
    ValueTypes.percentageOfGoodValues
];

export const identifierValues: KeyValuePair<string, string>[] = [ValueTypes.average, ValueTypes.gradient];

export const validatedValues: KeyValuePair<string, string>[] = [
    ValueTypes.validatedvalue,
    ValueTypes.manualvalue,
    ValueTypes.value
    // selection is added only with wtValueSelection with hasSelection="true"
    // ValueTypes.selection
    // comment is added only with wtValueSelection with hasComment="true"
    // ValueTypes.comment
];

export const reconciledValues: KeyValuePair<string, string>[] = [
    ValueTypes.reconciledValue,
    ValueTypes.reconciledPenalty,
    ValueTypes.reconciledUncertainty,
    ValueTypes.reconciledToreconcilevalue
];

export const targetValues: KeyValuePair<string, string>[] = [
    ValueTypes.sourceValue,
    ValueTypes.targetValue,
    ValueTypes.deviation,
    ValueTypes.relativeDeviation
];

export const reconciledConstraints: KeyValuePair<string, string>[] = [ValueTypes.reconciledConstraint, ValueTypes.reconciledTarget];

export const severityLevels: KeyValuePair<AlarmLevel, string>[] = [
    { key: AlarmLevel.Information, value: 'Information' },
    { key: AlarmLevel.Warning, value: 'Warning' },
    { key: AlarmLevel.Critical, value: 'Critical' }
];

export class Roles {
    static administrator = 'Administrator';
    static reader = 'Reader';
    static master = 'Master';
    static superAdministrator = 'Super-administrator';
    static operator = 'Operator';
    static engineer = 'Engineer';

    static applicationVisibilityRoles: string[] = [Roles.superAdministrator, Roles.administrator, Roles.engineer, Roles.master];

    static jobsDefinitionRoles: string[] = [Roles.administrator, Roles.master, Roles.engineer];
    static updateDatabaseRoles: string[] = [Roles.administrator, Roles.master, Roles.engineer];
    static acquisitionRoles: string[] = [Roles.master, Roles.engineer, Roles.operator];
    static manualInputRoles: string[] = [Roles.master, Roles.engineer, Roles.operator];
    static validationRoles: string[] = [Roles.master, Roles.operator];
    static editDocumentationRoles: string[] = [Roles.engineer, Roles.administrator];
    static editDashboardDocumentationRoles: string[] = [Roles.master, Roles.engineer, Roles.administrator];
    static idleRoles: string[] = [Roles.master, Roles.engineer, Roles.administrator];
}

export const allTimeUnits: KeyValuePair<TimeUnit, string>[] = [
    { key: TimeUnit.Second, value: 'Second' },
    { key: TimeUnit.Minute, value: 'Minute' },
    { key: TimeUnit.Hour, value: 'Hour' },
    { key: TimeUnit.Day, value: 'Day' },
    { key: TimeUnit.Week, value: 'Week' },
    { key: TimeUnit.Month, value: 'Month' },
    { key: TimeUnit.Year, value: 'Year' }
];

export const timeUnits: KeyValuePair<TimeUnit, string>[] = [
    { key: TimeUnit.Hour, value: 'Hour' },
    { key: TimeUnit.Day, value: 'Day' },
    { key: TimeUnit.Week, value: 'Week' },
    { key: TimeUnit.Month, value: 'Month' },
    { key: TimeUnit.Year, value: 'Year' }
];

export const tableAggregationModes: KeyValuePair<AggregationMode, string>[] = [
    { key: AggregationMode.None, value: 'None' },
    { key: AggregationMode.Average, value: 'Average' },
    { key: AggregationMode.Sum, value: 'Sum' }
];

export const noneApplication: Application = {
    allowedUserCollection: [],
    backgroundUrl: '',
    creationDate: '',
    creationUser: '',
    computeAlarmsRanges: false,
    dayBeginTime: 0,
    defaultConnectionPointGuid: guidEmpty,
    documentation: '',
    guid: guidEmpty,
    ignoreErrors: false,
    identifiersCount: 0,
    isChildApplicationCreationAllowed: false,
    isFavorite: false,
    isIdleMode: false,
    isLocked: false,
    lastModificationDate: '',
    lastModifier: '',
    longComment: '',
    name: '',
    olsonTimeZoneName: '',
    parentApplicationGuid: guidEmpty,
    roles: [],
    shortComment: '',
    validationEnabled: false,
    weekBeginDay: 0
};

export const tagProperties: BulkEditProperty[] = [
    { key: 'DataSheet', value: 'Data sheet', type: PropertyType.Text },
    {
        key: 'ActualDataType',
        value: 'Data type',
        type: PropertyType.Select,
        extraData: {
            options: [
                { key: ActualDataType.Float, value: 'Float' },
                { key: ActualDataType.Digital, value: 'Digital' },
                { key: ActualDataType.Timestamp, value: 'Timestamp' },
                { key: ActualDataType.String, value: 'String' }
            ]
        }
    },
    {
        key: 'AcquisitionStrategy',
        value: 'Strategy',
        type: PropertyType.Select,
        extraData: {
            options: [
                { key: AcquisitionStrategy.Default, value: 'Default' },
                { key: AcquisitionStrategy.PreviousStep, value: 'Previous step' }
            ]
        }
    },
    { key: 'DefaultValue', value: 'Default value', type: PropertyType.Number },
    { key: 'Documentation', value: 'Documentation', type: PropertyType.Text },
    { key: 'LongComment', value: 'Long comment', type: PropertyType.Text },
    { key: 'Min', value: 'Min', type: PropertyType.Number },
    { key: 'Max', value: 'Max', type: PropertyType.Number },
    { key: 'Name', value: 'Name', type: PropertyType.Text },
    { key: 'PFD', value: 'PFD', type: PropertyType.Text },
    { key: 'PID', value: 'PID', type: PropertyType.Text },
    { key: 'Resolution', value: 'Resolution', type: PropertyType.Number },
    { key: 'ResolutionPercentage', value: 'Resolution %', type: PropertyType.Number },
    { key: 'ShortComment', value: 'Short comment', type: PropertyType.Text },
    { key: 'StdDevThreshold', value: 'Std dev threshold', type: PropertyType.Number },
    { key: 'AcquisitionPointGuid', value: 'Source', type: PropertyType.ConnectionPoint, extraData: { types: tagSourceConnectionPointTypes } },
    { key: 'SourceUnitGuid', value: 'Source unit', type: PropertyType.UnitWithEmpty },
    // #20994 : we decided to remove variable type in matching mode has it leads to inconsistent unit
    //{ key: 'VariableTypeGuid', value: 'Variable type', type: PropertyType.VariableType, onlyMatching: true},
    { key: 'VariableSubTypeGuid', value: 'Variable subtype', type: PropertyType.VariableSubType, onlyMatching: true },
    { key: 'QualifierGuid', value: 'Qualifier', type: PropertyType.Qualifier, onlyMatching: true },
    { key: 'UnitGuid', value: 'Unit', type: PropertyType.Unit, onlyMatching: true },
    { key: 'IsReviewRequired', value: 'Requires review', type: PropertyType.Boolean },
    { key: 'IsIgnored', value: 'Ignored', type: PropertyType.Boolean },
    { key: 'LagSpan', value: 'Offset', type: PropertyType.Frequency, extraData: { disableFrequencyValidation: true } },
    { key: 'ValidityPeriod', value: 'Validity period', type: PropertyType.Frequency, extraData: { disableFrequencyValidation: true } },
    { key: 'FlatMode', value: 'Flat mode', type: PropertyType.FlatMode },
    {
        key: 'VariablesAndUnit',
        value: 'Variable and unit',
        values: ['Variable subtype', 'Qualifier', 'Unit'],
        type: PropertyType.VariablesAndUnit,
        onlyNotMatching: true
    }
];

export const groupProperties: { key: string; value: string; type: PropertyType }[] = [
    { key: 'Type', value: 'Type', type: PropertyType.Text },
    { key: 'ShortComment', value: 'Short comment', type: PropertyType.Text },
    { key: 'LongComment', value: 'Long comment', type: PropertyType.Text },
    { key: 'Documentation', value: 'Documentation', type: PropertyType.Text },
    //{ key: 'TemplateGuid', value: 'Template', type: PropertyType.Template },
    { key: 'Frequency', value: 'Frequency', type: PropertyType.Frequency },
    { key: 'ConfigMode', value: 'Validation', type: PropertyType.ValidationConfigMode },
    { key: 'ApprovalStrategyGuid', value: 'Approval strategy', type: PropertyType.ApprovalStrategyGuid }
];

export const userSettings = {
    treePinned: 'treePinned',
    connectionPointSelected: 'connectionPointSelected'
};

export const headerStyles: KeyValuePair<HeaderStyle, string>[] = [
    { key: HeaderStyle.Default, value: 'Default' },
    { key: HeaderStyle.Compact, value: 'Compact' },
    { key: HeaderStyle.None, value: 'None' }
];

export const sortByOptionsTableByGroup: KeyValuePair<string, string>[] = [
    { key: 'absoluteName', value: 'Model hierarchy' },
    { key: 'shortComment', value: 'Short comment' },
    { key: 'longComment', value: 'Long comment' },
    { key: 'uniqueName', value: 'Group unique name' }
];

export const defaultTagRenamingStrategies: KeyValuePair<TagRenamingStrategy, string>[] = [
    { key: TagRenamingStrategy.GenerateTagNames, value: 'Generate tag names' },
    { key: TagRenamingStrategy.UseOriginalTags, value: 'Use original tags' }
];

export * from './AlarmModes';
export * from './dateFormats';
export * from './dashboardPeriods';
export * from './manualInputDateFormats';
